import { $ } from '@/libs/jquery/index'

$.validator.addMethod('passportPlaceWithCode', function(value: string, element: HTMLElement): boolean {
  // если данные не из дадаты, то не валидируем их
  const getDadata = $(element).data('getdadata') === 1
  let isCodeValid: boolean = false

  if (getDadata) {
    // достаем код подразделения XXX-XXX - всего 7 - должно быть в начале строки
    const code = value.slice(0, 7)
    isCodeValid = $.validator.methods.passportcode.call(this, code, element)
  }

  return getDadata
    ? isCodeValid
    : true
}, 'Некорректно заполнено поле, посмотрите пример заполнения')
